/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Select, SelectItem, Spinner, User } from '@nextui-org/react';
import { IconArrowLeft } from '@tabler/icons-react';
import React, { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { classNames, Constants, copy, fromPhotos } from '../../../../utils';
//import { SchoolService, UsersService } from '../../../../services';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Calendar from '../../../../components/calendar';
import moment from 'moment';
import { TeacherAttendeceService, TeacherStudentSerivce } from '../../../../services';


const AssitenceCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { form, grades, isLoading, onChange, sections, onSubmit, lapses, currentLapse } = useFetchTable(location.state);


  return (
    <div className="flex gap-4">
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <aside className="bg-foreground-200 w-[45%] h-full p-4 rounded-lg flex flex-col gap-4">
        <div className="flex gap-4">
          <IconArrowLeft className="cursor-pointer" onClick={() => navigate('/assistance', { replace: true })} />
          <p className="font-bold text-secondary capitalize">{location?.state?.name} - {location?.state?.school_grade?.name}</p>
        </div>


        <Filters
          grades={grades}
          sections={sections}
          lapses={lapses}
          onChange={onChange}
        />
        <Calendar
          minValue={currentLapse?.init_date}
          maxValue={currentLapse?.end_date}
          calendarWidth={350}
          value={form.date}
          onChange={(value) => onChange(value, 'date')}
        />

        <div className='flex w-full justify-center items-center'>
          <Button
            variant="flat"
            className="bg-green text-white font-semibold w-[20rem]"
            onClick={onSubmit}
          >
            Guardar
          </Button>
        </div>
      </aside>


      <main className="text-sm w-[50%] last:rounded-b-lg last:overflow-hidden">
        <div
          className='grid grid-cols-4 rounded-t-lg bg-foreground-500 text-white [&>div]:p-2'
        >
          <div className="th font-semibold col-span-2 pl-2">Estudiantes</div>
          <div className="th font-semibold text-center">Presente</div>
          <div className="th font-semibold text-center">Ausente</div>
        </div>
        {form.students.map((user, userIdx) => (
          <div
            key={user.id}
            className="grid grid-cols-4 [&>div]:px-2 border-t border-t-foreground-300"
          >
            <div className="col-span-2 bg-foreground-200 py-2">
              <User
                avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(user.photo) : null }}
                name={user?.fullName}
                classNames={{ description: 'text-foreground-500' }}
              />
            </div>
            <div className="flex justify-center items-center">
              <div
                className={classNames(
                  'w-4 h-4 rounded-full border-1 cursor-pointer',
                  form.students[userIdx].status === Constants.ATTENDENCE_STATUS.PRESENT
                    ? 'bg-green border-green'
                    : 'bg-foreground-300 border-foreground-400',
                )}
                onClick={() => onChange(Constants.ATTENDENCE_STATUS.PRESENT, 'status', userIdx)}
              />

            </div>
            <div className="flex justify-center items-center">
              <div
                className={classNames(
                  'w-4 h-4 rounded-full border-1 cursor-pointer',
                  form.students[userIdx].status === Constants.ATTENDENCE_STATUS.ABSENT
                    ? 'bg-danger border-danger'
                    : 'bg-foreground-300 border-foreground-400',
                )}
                onClick={() => onChange(Constants.ATTENDENCE_STATUS.ABSENT, 'status', userIdx)}
              />
            </div>
          </div>
        ))}
      </main>
    </div>
  )
}


const Filters = ({ sections, lapses, onChange }) => {
  const initialForm = {
    school_grade_id: '',
    school_section_id: '',
    school_lapse_id: '',
  };
  const [form, setForm] = useState(initialForm);


  const change = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    onChange(value, target);
  }


  return (
    <section className='flex items-center gap-4'>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_section_id ? [form.school_section_id] : []}
        onSelectionChange={v => change(v.currentKey, 'school_section_id')}
      >
        {sections.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      <Select
        label="Lapso"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_lapse_id ? [form.school_lapse_id] : []}
        onSelectionChange={v => change(v.currentKey, 'school_lapse_id')}
      >
        {lapses.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
    </section>
  )
}

const useFetchTable = (subject) => {

  const initialForm = {
    subject_id: subject?.id,
    school_grade_id: subject?.school_grade_id,
    school_year_id: subject?.school_grade?.school_year_id,
    school_section_id: '',
    school_lapse_id: '',
    date: moment().format('YYYY-MM-DD'),
    students: [],
  };
  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState(initialForm);
  const [lapses, setLapses] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);


  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const currentLapse = useMemo(() => lapses.find(x => x.value === String(form.school_lapse_id)), [form.school_lapse_id, lapses])

  const fetchData = async () => {
    if (!form.school_section_id || !form.subject_id || !form.school_lapse_id || !form.date) return;
    if (!canFetch) return;
    setCanFetch(false);
    try {

      const attendences = await TeacherAttendeceService.attendence.getAttendence({
        professor_id: user.id,
        subject_id: +form.subject_id,
        school_lapse_id: +form.school_lapse_id,
        school_section_id: +form.school_section_id,
        date: form.date,
      })


      const students = await TeacherStudentSerivce.student.getStudents({
        user_id: user.id,
        school_grade_id: +form.school_grade_id,
        school_section_id: +form.school_section_id,
        perPage: 999
      });

      const { data } = students;

      setForm(s => ({
        ...s,
        students: data.map((student) => {
          const attendence = attendences.find(x => x.student_id === student.id);
          return {
            id: student.id,
            fullName: student.fullname,
            photo: student.photo,
            status: attendence?.status ?? null,
          }
        }),
      }));

      setCanFetch(true);

    } catch (error) {
      onError(String(error));
      setCanFetch(true);
    }
  }

  const isValidForm = () => {
    if (!form.school_grade_id) {
      onError('Debe seleccionar el grado');
      return false;
    }

    if (!form.school_section_id) {
      onError('Debe seleccionar la sección');
      return false;
    }

    if (!form.school_lapse_id) {
      onError('Debe seleccionar el lapso');
      return false;
    }

    if (!form.students.length) {
      onError('Debe seleccionar al menos un estudiante');
      return false;
    }

    if (form.students.some(x => x.status === null)) {
      onError('Debe marcar a todos los estudiantes como presentes o ausentes');
      return false;
    }

    if (!form.date) {
      onError('Debe seleccionar una fecha');
      return false;
    }

    if (moment(form.date).isBefore(currentLapse?.init_date) || moment(form.date).isAfter(currentLapse?.end_date)) {
      onError('La fecha debe estar dentro del lapso');
      return false;
    }

    return true;
  }

  const fetchSelects = async () => {
    try {
      const selects = await TeacherAttendeceService.attendence.getSelects({ professor_id: user.id });
      setGrades(toSelect(selects.grades));
      setLapses(toSelect(selects.lapses));
      setSections(toSelect(selects.sections));
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const onChange = (value, target, index) => {
    if (target === 'status') {
      const _form = copy(form);
      _form['students'][index][target] = _form['students'][index][target] === value ? null : value;
      return setForm(_form);
    }

    setForm(s => ({ ...s, [target]: value }));
  }

  const onError = (msg) => toast.error(msg);


  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      const data = {
        ...form,
        professor_id: user.id,
        attendeces: form.students.map((x) => ({
          student_id: x.id,
          status: x.status,
        }))
      }
      await TeacherAttendeceService.attendence.createAttendence(data);

      toast.success('Asistencia tomada correctamente');
      fetchData();
    } catch (error) {
      onError(String(error));
    }
  }

  useEffect(() => {
    fetchData();
  }, [form.school_section_id, form.subject_id, form.school_lapse_id, form.date]);

  useEffect(() => {
    fetchSelects();
  }, [])

  return {
    data,
    form,
    onChange,
    isLoading: !canFetch,
    sections: sections.filter(x => x.school_grade_id === +form.school_grade_id),
    onSubmit,
    grades,
    lapses: lapses.filter(x => x.school_year_id === +form.school_year_id),
    currentLapse,
  }
}

export default AssitenceCreate;